import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GestionEspacialComponent } from './gestion-espacial.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [GestionEspacialComponent],
  imports: [
    CommonModule,
    SharedModule,
  ]
})
export class GestionEspacialModule { }
